<template>
  <div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto" v-if="isLoadData">
            <div class="row mt-3 d-flex align-items-left">
              <div class="d-flex flex-wrap align-items-center justify-content-between mb-2 gap-2">
                <div class="search-wrapper">
                  <FormSearch :onChangeSearchParameter="onChangeSearchParameter" />
                </div>
                <div class="d-flex align-items-center auto-reset-toggle">
                  <span class="title-page fs-16 me-3">Auto Reset to ON everyday</span>
                  <div
                    :class="{
                      active: autoResetToOnEveryday == 1,
                    }"
                    class="toggle_container"
                  >
                    <MaterialToggleButton
                      labelEnableText=""
                      labelDisableText=""
                      id="auto_reset_to_on_everyday"
                      :defaultState="autoResetToOnEveryday == 1"
                      v-on:change="handleChangeAutoReset"
                      class="mb-0"
                    />
                  </div>
                </div>
              </div>
              <div class="row align-items-center">
                <div class="col-lg-3 col-6 d-flex mt-3">
                  <div
                    class="cursor-pointer"
                    :class="{
                      'title-page fs-16 text-decoration-underline':
                        itemType === 1,
                    }"
                    @click="changeItemType(1)"
                  >
                    Main
                  </div>
                  <div class="mx-3">|</div>
                  <div
                    class="cursor-pointer"
                    :class="{
                      'title-page fs-16 text-decoration-underline':
                        itemType === 2,
                    }"
                    @click="changeItemType(2)"
                  >
                    Modifier
                  </div>
                </div>
                <div class="col-lg-3 col-6 d-flex mt-3">
                  <div
                    class="cursor-pointer"
                    :class="{
                      'title-page fs-16 text-decoration-underline':
                        fieldDisplay === 1,
                    }"
                    @click="changeFieldDisplay(1)"
                  >
                    Name
                  </div>
                  <div class="mx-3">|</div>
                  <div
                    class="cursor-pointer"
                    :class="{
                      'title-page fs-16 text-decoration-underline':
                        fieldDisplay === 2,
                    }"
                    @click="changeFieldDisplay(2)"
                  >
                    Description
                  </div>
                </div>
                <div
                  class="col-lg-6 col-12 d-flex mt-3 d-flex justify-content-end"
                  v-if="isMobile == false"
                >
                  <material-button
                    :disabled="isBulkSaving"
                    @click="requirePasscode(() => handleEnableOrDisableAll(false))"
                    class="btn-background btn-sm me-3"
                  >
                    Disable
                  </material-button>
                  <material-button
                    :disabled="isBulkSaving"
                    @click="requirePasscode(() => handleEnableOrDisableAll(true))"
                    class="btn-background btn-sm"
                  >
                    Enable
                  </material-button>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table
                        class="table align-items-center mb-0"
                        style="color: #222"
                      >
                        <thead>
                          <tr>
                            <th
                              class="text-center font-weight-bolder w-5"
                              v-if="isMobile == false"
                            >
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  :checked="isAllSelected"
                                  @change="selectAll"
                                />
                              </div>
                            </th>
                            <th
                              class="font-weight-bolder w-20 position-relative"
                              @click="handleChangeSortColumn(1)"
                            >
                              <span
                                :class="[
                                  'wrapper-sortby pointer',
                                  ESortDirectionSelect.idx == 1
                                    ? ESortDirectionSelect.direction ===
                                      ESortDirection.Desc
                                      ? 'sort-desc'
                                      : 'sort-asc'
                                    : '',
                                ]"
                                >{{ isMobile ? $t("No") : $t("Item No") }}</span
                              >
                            </th>
                            <th
                              class="font-weight-bolder w-30 position-relative"
                              @click="
                                handleChangeSortColumn(
                                  fieldDisplay === 1 ? 2 : 3
                                )
                              "
                            >
                              <span
                                :class="[
                                  'wrapper-sortby pointer',
                                  [2, 3].includes(ESortDirectionSelect.idx)
                                    ? ESortDirectionSelect.direction ===
                                      ESortDirection.Desc
                                      ? 'sort-desc'
                                      : 'sort-asc'
                                    : '',
                                ]"
                                >{{
                                  fieldDisplay === 1
                                    ? $t("Item Name")
                                    : $t("Description")
                                }}</span
                              >
                            </th>
                            <th class="font-weight-bolder w-20">
                              {{ $t("On Off") }}
                            </th>
                            <th class="font-weight-bolder w-25">
                              {{ $t("Count Down") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="items.length">
                          <tr v-for="value in items" :key="value.id">
                            <td
                              class="text-center text-xss w-5"
                              v-if="isMobile == false"
                            >
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  :value="value.id"
                                  v-model="selectedItems"
                                />
                              </div>
                            </td>
                            <td
                              class="text-xss w-20 fs-16 min-w-75px"
                              style="
                                max-width: 20%;
                                width: 200px;
                                white-space: normal;
                                word-break: break-word;
                              "
                            >
                              {{ value.item_no }}
                            </td>
                            <td
                              class="text-xss w-30 fs-16 min-w-200px"
                              style="
                                max-width: 50%;
                                width: 300px;
                                white-space: normal;
                                word-break: break-word;
                              "
                            >
                              {{
                                fieldDisplay === 1
                                  ? value.item_name
                                  : value.description
                              }}
                            </td>
                            <td class="text-xss w-20 min-w-75px">
                              <div
                                :class="{
                                  active:
                                    value.is_not_available == 0 ? true : false,
                                }"
                                class="toggle_container"
                              >
                                <MaterialToggleButton
                                  labelEnableText=""
                                  labelDisableText=""
                                  :id="value.id + 'event_handle_available'"
                                  v-on:change="triggerEventAvailable($event, value)"
                                  class="mb-0"
                                  :disabled="isRowSaving(value.id)"
                                />
                              </div>
                            </td>
                            <td class="text-xss w-25 min-w-200px">
                              <div
                                style="display: flex; align-items: center"
                                v-if="!value.stock_enable_balance"
                              >
                                <div class="me-1">
                                  {{ value.stock_balance }}
                                </div>
                                <MaterialToggleButton
                                  labelEnableText=""
                                  labelDisableText=""
                                  :id="value.id + 'event_handle_stock_on_off'"
                                  v-on:change="triggerEventStockOnOff($event, value)"
                                  class="mb-0"
                                  :disabled="
                                    value.is_not_available != 0 ||
                                    isRowSaving(value.id)
                                  "
                                />
                              </div>
                              <div
                                style="display: flex; align-items: center"
                                v-else
                              >
                                <material-input
                                  v-model="value.stock_balance"
                                  type="text"
                                  class="text-stock-balance"
                                  style="min-width: 100px;"
                                />
                                <material-button
                                  size="sm"
                                  class="save-stock-btn mx-1"
                                  :disabled="isRowSaving(value.id)"
                                  @click="handleSaveStock(value)"
                                >
                                  {{ $t("Save") }}
                                </material-button>
                                <div
                                  :class="{
                                    active:
                                      value.stock_enable_balance == 1
                                        ? true
                                        : false,
                                  }"
                                  class="toggle_container"
                                >
                                  <MaterialToggleButton
                                    labelEnableText=""
                                    labelDisableText=""
                                    :id="value.id + 'event_handle_stock_on_off'"
                                    v-on:change="triggerEventStockOnOff($event, value)"
                                    class="mb-0"
                                    :disabled="isRowSaving(value.id)"
                                  />
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="10" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import MaterialToggleButton from "@/components/MaterialToggleButton.vue";
import ItemService from "../../../services/product/item.service";
import "@vueform/multiselect/themes/default.css";
import MaterialInput from "@/components/MaterialInput.vue";
import FormSearch from "./FormSearch.vue";
import MaterialButton from "@/components/MaterialButton.vue";

export default {
  name: "StockManagement",
  components: {
    MaterialToggleButton,
    MaterialInput,
    FormSearch,
    MaterialButton,
  },
  props: {
    showLoader: {
      type: Function,
      required: true,
    },
    hideLoader: {
      type: Function,
      required: true,
    },
    showNotification: {
      type: Function,
      required: true,
    },
    getPhysicalBranch: {
      type: Function,
      required: true,
    },
    // The page level passcode gate, owned by StockByPhysicalBranch.
    requirePasscode: {
      type: Function,
      required: true,
    },
    handlePasscodeRequired: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      form: {
        search_keyword: "",
      },
      isLoadData: false,
      selectedItems: [],
      isMobile: false,
      ESortDirectionSelect: {
        idx: null,
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      itemType: 1, // 1: Main, 2: Modifier
      fieldDisplay: 1, // 1: Name, 2: Description
      autoResetToOnEveryday: 0,
      savingItemIds: [],
      isBulkSaving: false,
      resizeTimeout: null,
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.checkWindowSize();
    window.addEventListener("resize", this.debouncedCheckWindowSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debouncedCheckWindowSize);
    clearTimeout(this.resizeTimeout);
  },
  methods: {
    checkWindowSize() {
      if (window.innerWidth < 1200) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },

    debouncedCheckWindowSize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.checkWindowSize, 200);
    },

    handleChangeAutoReset(event) {
      if (typeof event !== "boolean") return;

      this.requirePasscode(() => this.updateAutoResetStock());
    },

    updateAutoResetStock() {
      this.showLoader();
      var dataForm = {
        branchId: this.branchId,
        merchantId: this.merchantId,
      };

      ItemService.updateAutoResetStock(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            // The API flips the stored flag itself, so the new value is derived
            // from what is on screen rather than from the toggle event - the two
            // drift apart as soon as a passcode prompt is cancelled mid-click.
            this.autoResetToOnEveryday = this.autoResetToOnEveryday == 1 ? 0 : 1;
            this.showNotification(
              "Auto reset setting updated successfully!",
              "success"
            );
          } else if (
            !this.handlePasscodeRequired(response, () =>
              this.updateAutoResetStock()
            )
          ) {
            this.showNotification(response.data.result.message, "danger");
          }
          this.hideLoader();
        },
        (error) => {
          this.showNotification(error.response.data.result.message, "danger");
          this.hideLoader();
        }
      );
    },

    changeItemType(type) {
      this.itemType = type;
      this.getList();
    },

    changeFieldDisplay(field) {
      this.fieldDisplay = field;
    },

    onChangeSearchParameter(value, fieldName) {
      this.form[fieldName] = value !== null ? value : "";

      this.getList();
    },

    getList() {
      this.showLoader();
      var dataForm = {
        search_keyword: this.form.search_keyword,
        merchantId: this.merchantId,
        branchId: this.branchId,
        sortCol: this.ESortDirectionSelect.idx,
        sortType: this.ESortDirectionSelect.direction,
        itemType: this.itemType,
      };

      ItemService.getAllStockItemsByPhysicalBranch(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.items = response.data.data.items;
            this.autoResetToOnEveryday = response.data.data.physical_branch?.auto_reset_to_on_everyday ?? 0;
            this.getPhysicalBranch(response.data.data.physical_branch);
            this.isLoadData = true;
          } else {
            this.showNotification(response.data.result.message, "danger");
          }
          this.hideLoader();
        },
        (error) => {
          this.showNotification(error, "danger");
          this.hideLoader();
        }
      );
    },
    handleChangeSortColumn(idx) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          direction: this.ESortDirection.Asc,
        };
      }

      if (this.items.length) {
        this.getList();
      }
    },
    selectAll(event) {
      if (event.target.checked) {
        this.selectedItems = this.items.map((item) => item.id);
      } else {
        this.selectedItems = [];
      }
    },
    handleEnableOrDisableAll(is_disabled) {
      if (this.isBulkSaving) return;
      if (this.selectedItems && this.selectedItems.length > 0) {
        this.isBulkSaving = true;
        this.showLoader();
        var dataForm = {
          is_disabled: is_disabled,
          selectedItems: this.selectedItems,
          branchId: this.branchId,
          merchantId: this.merchantId,
        };
        ItemService.handleEnableOrDisableAvailableAll(dataForm)
          .then(
            (response) => {
              if (response.data.result.isSuccess) {
                const newIsNotAvailable = is_disabled ? 0 : 1;
                this.items.forEach((item) => {
                  if (this.selectedItems.includes(item.id)) {
                    item.is_not_available = newIsNotAvailable;
                  }
                });
                this.showNotification(
                  is_disabled
                    ? "Items enabled successfully!"
                    : "Items disabled successfully!",
                  "success"
                );
              } else if (
                !this.handlePasscodeRequired(response, () =>
                  this.handleEnableOrDisableAll(is_disabled)
                )
              ) {
                this.showNotification(response.data.result.message, "danger");
              }
            },
            (error) => {
              this.showNotification(error, "danger");
            }
          )
          .finally(() => {
            this.isBulkSaving = false;
            this.hideLoader();
          });
      } else {
        this.showNotification(
          "You must select least 1 column to export file.",
          "danger"
        );
      }
    },
    isRowSaving(id) {
      return this.savingItemIds.includes(id);
    },
    handleEnableOrDisable(item) {
      if (this.isRowSaving(item.id)) return;
      this.savingItemIds.push(item.id);
      this.showLoader();
      var dataForm = {
        id: item.id,
        value: item.is_not_available ? 0 : 1,
        branchId: this.branchId,
        merchantId: this.merchantId,
      };
      ItemService.handleEnableOrDisableAvailable(dataForm)
        .then(
          (response) => {
            if (response.data.result.isSuccess) {
              item.is_not_available = dataForm.value;
              if (dataForm.value != 0) {
                item.stock_enable_balance = null;
              }
              this.showNotification(
                dataForm.value != 0
                  ? "Item disabled successfully!"
                  : "Item enabled successfully!",
                "success"
              );
            } else if (
              !this.handlePasscodeRequired(response, () =>
                this.handleEnableOrDisable(item)
              )
            ) {
              this.showNotification(response.data.result.message, "danger");
            }
          },
          (error) => {
            this.showNotification(error, "danger");
          }
        )
        .finally(() => {
          this.savingItemIds = this.savingItemIds.filter((id) => id !== item.id);
          this.hideLoader();
        });
    },
    triggerEventAvailable(event, value) {
      if (typeof event == "boolean") {
        this.requirePasscode(() => this.handleEnableOrDisable(value));
      }
    },
    triggerEventStockOnOff(event, value) {
      if (typeof event == "boolean") {
        this.requirePasscode(() => this.handleStockOnOff(value));
      }
    },
    handleSaveStock(item) {
      this.requirePasscode(() => this.onChangeStock(item));
    },
    onChangeStock(item) {
      if (this.isRowSaving(item.id)) return;
      this.savingItemIds.push(item.id);
      this.showLoader();
      var dataForm = {
        id: item.id,
        stock_balance: item.stock_balance,
        branchId: this.branchId,
        merchantId: this.merchantId,
      };
      ItemService.updateStockBalanceByItem(dataForm)
        .then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.showNotification(
                "Stock balance updated successfully!",
                "success"
              );
            } else if (
              !this.handlePasscodeRequired(response, () =>
                this.onChangeStock(item)
              )
            ) {
              this.showNotification(response.data.result.message, "danger");
            }
          },
          (error) => {
            this.showNotification(error, "danger");
          }
        )
        .finally(() => {
          this.savingItemIds = this.savingItemIds.filter((id) => id !== item.id);
          this.hideLoader();
        });
    },
    handleStockOnOff(item) {
      if (this.isRowSaving(item.id)) return;
      this.savingItemIds.push(item.id);
      this.showLoader();
      var dataForm = {
        id: item.id,
        value: item.stock_enable_balance ? 0 : 1,
        branchId: this.branchId,
        merchantId: this.merchantId,
      };
      ItemService.handleStockOnOff(dataForm)
        .then(
          (response) => {
            if (response.data.result.isSuccess) {
              item.stock_enable_balance = dataForm.value;
              this.showNotification(
                dataForm.value
                  ? "Stock tracking enabled successfully!"
                  : "Stock tracking disabled successfully!",
                "success"
              );
            } else if (
              !this.handlePasscodeRequired(response, () =>
                this.handleStockOnOff(item)
              )
            ) {
              this.showNotification(response.data.result.message, "danger");
            }
          },
          (error) => {
            this.showNotification(error, "danger");
          }
        )
        .finally(() => {
          this.savingItemIds = this.savingItemIds.filter((id) => id !== item.id);
          this.hideLoader();
        });
    },
  },
  computed: {
    merchantId() {
      return this.$route.params.merchant_id;
    },
    branchId() {
      return this.$route.params.branch_id;
    },
    isAllSelected: {
      get() {
        return (
          this.selectedItems && this.selectedItems.length === this.items.length
        );
      },
      set(value) {
        if (value) {
          this.selectedItems = this.items.map((item) => item.id);
        } else {
          this.selectedItems = [];
        }
      },
    },
  },
};
</script>
<style scoped>
tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.wrapper-sortby::after {
  bottom: 6px;
  right: 20px;
}
.wrapper-sortby::before {
  bottom: 7px;
  right: 20px;
}

.search-wrapper {
  flex: 1;
  min-width: 200px;
}

.auto-reset-toggle {
  flex-shrink: 0;
}

.fs-16 {
  font-size: 16px !important;
}

.min-w-75px {
  min-width: 75px !important;
}

.min-w-200px {
  min-width: 200px !important;
}

.toggle_container {
  display: flex;
  align-items: center;
}

.save-stock-btn {
  padding: 0.25rem 0.5rem !important;
  font-size: 0.7rem !important;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 90px !important;
}

.toggle__button {
  display: contents;
}

@media (max-width: 991.98px) {
  .table.align-items-center th,
  .table.align-items-center td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

@media (max-width: 500px) {
  .min-w-75px {
    min-width: 75px !important;
    max-width: 75px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .min-w-200px {
    min-width: 175px !important;
    max-width: 175px !important;
  }

  .search-wrapper {
    flex: unset;
    width: 100%;
    min-width: unset;
  }

  .auto-reset-toggle {
    margin-top: 1rem;
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
